import { Fragment, useState } from 'react'
import callApi from '../../helpers/callapi'
import { useDispatch, useSelector } from 'react-redux'
import * as Utils from '../../helpers/utils'
import { handleEnterKey } from '../../helpers/checkEnter'
import axios from 'axios'
import configs from '../../config'
import { useHistory } from 'react-router-dom'

import { Card, Form, Row, Col, Button, Table } from 'react-bootstrap'

let arrayBase64 = []

const RecheckPrizes = () => {
  const history = useHistory()
  const [displayFile, setDisplayFile] = useState([])
  const [fileName, setFileName] = useState([])
  const [resultQr, setResultQr] = useState([])
  const [inputDataLotteries, setInputDataLotteries] = useState([])
  const [verify, setVerify] = useState({ lotto: [], remain: {} })
  const [remain, setRemain] = useState({})
  const { roundDate } = useSelector((state) => state.webConfig)

  arrayBase64 = Utils.arrayBase64

  const dispatch = useDispatch()

  const displayImage = (files) => {
    dispatch({ type: 'loading_show' })
    let pathImages = []
    let fileName = []
    Object.keys(files).forEach((key) => {
      pathImages.push(URL.createObjectURL(files[key]))
      fileName.push(files[key].name)
      Utils.getBase64(files[key])
    })

    setDisplayFile(pathImages)
    setFileName(fileName)
    dispatch({ type: 'loading_hide' })
  }

  const scanningLotteries = async () => {
    try {
      dispatch({ type: 'loading_show' })
      let arr = []
      if (arrayBase64.length > 0) {
        arrayBase64.map(async (v, i) => {
          arr.push(
            callApi({
              url: '/prizes/read-qr',
              method: 'post',
              body: { base64: v, filename: fileName[i] },
            }),
          )
        })

        const rs = await Promise.all(arr)
        const lotteries = rs.map((v) => v.result)
        setResultQr(lotteries)
        setInputDataLotteries(lotteries)
      }
    } catch (e) {
      console.log({ error: e })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const clearData = () => {
    setDisplayFile([])
    setFileName([])
    setResultQr([])
    setInputDataLotteries([])
    setVerify({ lotto: [], remain: {} })
    Utils.clearArrayBase64()
  }

  const removeLottery = (index) => {
    if (!window.confirm('ต้องการลบ Lottery ใบนี้ใช่ไหม')) {
      return
    }
    dispatch({ type: 'loading_show' })
    let cResultQr = [...resultQr]
    let cDisplayFile = [...displayFile]
    let cFileName = [...fileName]
    let cVerify = { ...verify }

    cResultQr.splice(index, 1)
    cDisplayFile.splice(index, 1)
    cFileName.splice(index, 1)
    cVerify.lotto.splice(index, 1)
    arrayBase64.splice(index, 1)

    setResultQr(cResultQr)
    setDisplayFile(cDisplayFile)
    setFileName(cFileName)
    setVerify(cVerify)
    arrayBase64 = arrayBase64
    dispatch({ type: 'loading_hide' })
  }

  const editResultQr = (index) => {
    let cResultQr = [...resultQr]
    cResultQr[index] = inputDataLotteries[index]
    setResultQr(cResultQr)
  }

  const verifyLotteries = async () => {
    try {
      dispatch({ type: 'loading_show' })
      const response = await axios.post(`${configs.adminApiGateway}/api/v1/admin/prizes/verify`, {
        roundDate,
        ids: resultQr,
      })
      designRemain(response.data.data.remain)
      setVerify(response.data.data)
    } catch (e) {
      console.log('verify prize error: ', e)
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const designRemain = (remains) => {
    console.log(remains)
    let cRemain = remains
    Object.keys(remains).forEach((group) => {
      if (Object.keys(remains[group]).length < 5) {
        cRemain[group]['remainLotto'] = ['-']
      }
    })
    setRemain(cRemain)
  }

  const confirmPrizes = async () => {
    try {
      dispatch({ type: 'loading_show' })
      let numberForConfirm = []

      resultQr.map((number, i) => {
        if (verify.lotto[i]) {
          numberForConfirm.push(number)
        }
      })

      await axios.post(`${configs.adminApiGateway}/api/v1/admin/prizes/confirm`, {
        roundDate,
        ids: numberForConfirm,
      })
    } catch (e) {
      console.log({ message: e })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const displayLotteries = () => {
    return (
      <Row>
        {displayFile &&
          displayFile.map((img, i) => {
            let style = 'bg-light'
            if (Object.keys(verify).length > 0 && verify.lotto.length > 0) {
              style = verify.lotto[i]
                ? 'bg-success-light border border-success'
                : 'bg-danger-light border border-danger'
            }
            return (
              <Col md={3} key={i}>
                <div className={`${style} p-2 my-2 text-right`}>
                  <p
                    href="#"
                    onClick={() => removeLottery(i)}
                    style={{ cursor: 'pointer' }}
                    className="pb-1 m-0 text-danger"
                  >
                    ลบ
                  </p>
                  <img src={img} alt="" width="100%" />
                  {resultQr.length > 0 && (
                    <div className="text-center text-primary pt-1">
                      {resultQr[i] ? (
                        resultQr[i]
                      ) : (
                        <Form.Control
                          type="text"
                          defaultValue={inputDataLotteries[i]}
                          onChange={(e) => {
                            const arr = [...inputDataLotteries]
                            arr[i] = e.target.value
                            setInputDataLotteries(arr)
                          }}
                          onKeyDown={handleEnterKey(() => editResultQr(i))}
                        />
                      )}
                    </div>
                  )}
                </div>
              </Col>
            )
          })}
      </Row>
    )
  }

  const displayButtonConfirm = () => {
    return (
      <Fragment>
        {Object.keys(verify.remain).length > 0 && verify.lotto.every((v) => v === true) && (
          <div className="my-5 text-center">
            <Button className="w-50" onClick={confirmPrizes}>
              CONFIRM
            </Button>
          </div>
        )}
      </Fragment>
    )
  }

  const displayLotteriesRemain = () => {
    if (Object.keys(verify.remain).length === 0) {
      return <></>
    }
    return (
      <div>
        <hr className="my-5" />
        <h3 className="text-center">จำนวนคงเหลือ</h3>
        <Table responsive striped className="text-center">
          <thead>
            <tr>
              <th>กอง</th>
              <th>จำนวนรางวัลที่พบ</th>
              <th>จำนวนลอตเตอรี่ที่พบ</th>
              <th>จำนวนรางวัลทั้งหมด</th>
              <th>จำนวนลอตเตอรี่ทั้งหมด</th>
              <th>ลอตเตอรี่ที่ยังหาไม่เจอ</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(remain).map((group) => {
              console.log('group', group)
              return (
                <tr>
                  <td>{group}</td>
                  {Object.keys(remain[group]).map((v) => {
                    console.log('remain[group][v]', remain[group][v])
                    return (
                      <td>
                        {remain[group][v] && remain[group][v].length ? (
                          <span>{remain[group][v].join(' : ')}</span>
                        ) : (
                          remain[group][v]
                        )}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
        {displayButtonConfirm()}
      </div>
    )
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Upload Lottery</Card.Title>
          <Button
            onClick={() => {
              history.push('/prizeDetail')
            }}
          >
            Detail
          </Button>
        </Card.Header>
        <Card.Body>
          <Form.Group>
            <Form.File
              type="file"
              multiple
              label="เลือกลอตเตอรี่"
              defaultValue={''}
              onChange={(e) => {
                displayImage(e.target.files)
              }}
              onClick={clearData}
            />
          </Form.Group>
          <hr />
          <div className="d-flex justify-content-center">
            {displayFile.length > 0 && (
              <Button variant="primary light mt-1 mb-3 w-50 " size="lg" onClick={scanningLotteries}>
                สแกน ลอตเตอรี่
              </Button>
            )}
            {resultQr.length > 0 && resultQr.every((v) => v != null) && (
              <Button variant="info light mt-1 mb-3 w-50 " size="lg" onClick={verifyLotteries}>
                ตรวจสอบ
              </Button>
            )}
          </div>
          {displayLotteries()}
          {displayButtonConfirm()}
          {displayLotteriesRemain()}
        </Card.Body>
      </Card>
    </Fragment>
  )
}

export default RecheckPrizes
